import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import storage from "redux-persist/es/storage";

// Layout
import LayoutReducer, { LayoutState } from "./layouts/reducer";
//Core Data
import CoreDataReducer, { CoreDataState } from "./core-data/reducer";

// login
import LoginReducer, { AuthState } from "./auth/login/reducer";



// register
import RegisterReducer, { RegisterState } from "./auth/register/reducer";
// userProfile
import ProfileReducer, { ProfileState } from "./auth/profile/reducer";
// Chat
import ChatReducer from "./chat/reducer";
// MailBox
import MailboxReducer from "./mailbox/reducer";
// Calendar
import CalendarReducer from "./calendar/reducer";
// Ecommerce
import EcommerceReducer from "./ecommerce/reducer";
// HR Managment
import HRManagmentReducer from "./hr-management/reducer";
// Notes
import NotesReducer from "./notes/reducer";
// Social
import SocialReducer from "./social/reducer";
// Invoice
import InvoiceReducer from "./invoice/reducer";
// Users
import UsersReducer from "./users/reducer";


const rootReducer = combineReducers({
    layout: LayoutReducer,
    auth: LoginReducer,
    coredata: CoreDataReducer,
    register: RegisterReducer,
    profile: ProfileReducer,
    chat: ChatReducer,
    mailbox: MailboxReducer,
    calendar: CalendarReducer,
    ecommerce: EcommerceReducer,
    hrManagment: HRManagmentReducer,
    notes: NotesReducer,
    social: SocialReducer,
    invoice: InvoiceReducer,
    users: UsersReducer,
});


//export type RootState = ReturnType<typeof rootReducer>;
export interface RootState {
    layout: LayoutState,
    auth: AuthState,
    coredata: CoreDataState,

    register: RegisterState,
    profile: ProfileState,

    chat: {
        chats: [],
        errors: {}
    },
    mailbox: {
        maillist: [],
        error: {},
        isLoader: false
    },
    calendar: {
        event: [],
        category: [],
        errors: {}
    },
    ecommerce: {
        orders: [],
        sellers: [],
        productList: [],
        productGrid: [],
        reviews: [],
        errors: {}
    },
    hrManagment: {
        employeelist: [],
        holidayslist: [],
        departmentslist: [],
        estimateslist: [],
        expenseslist: [],
        leaveManageHRlist: [],
        employeeSalarylist: [],
        attendancelist: [],
        mainAttendancelist: [],
        leaveManageEmployeelist: [],
        paymentslist: [],
        errors: {}
    },
    notes: {
        notes: [],
        errors: {}
    },
    social: {
        event: [],
        friendslist: [],
        errors: {}
    },
    invoice: {
        invoicelist: [],
        errors: {}
    },
    users: {
        userList: [],
        userGrid: [],
        errors: {}
    },
}

const persistConfig = {
    key: 'iclicks',
    storage: storage,
    whitelist: ['layout', 'auth'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ],
            },
        }),
});

export const persistor = persistStore(store);

//export const store = configureStore({ reducer: rootReducer, devTools: true });
export type AppDispatch = typeof store.dispatch;
